import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import {
  INFO_PAGE_HELPFULL_LINKS,
  InfoPageHelpfullLinksComponent,
} from './components/info-page-helpfull-links/info-page-helpfull-links.component';
import { BreadcrumbsComponent, BreadcrumbsService } from '../breadcrumbs';

@Component({
  selector: 'lib-info-page-layout',
  imports: [InfoPageHelpfullLinksComponent, BreadcrumbsComponent],
  templateUrl: './info-page-layout.component.html',
  styleUrl: './info-page-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoPageLayoutComponent implements OnInit {
  pageTitle = input.required();
  breadcrumbPageTitle = input.required();
  title = input<string>();
  subheading = input<string>();

  helpfullLinks = inject(INFO_PAGE_HELPFULL_LINKS);
  breadcrumbsService = inject(BreadcrumbsService);

  ngOnInit(): void {
    this.breadcrumbsService.set([this.breadcrumbPageTitle() as any]);
  }
}
